import { motion } from "framer-motion";
import { useStageMotion } from "./useStageMotion";
import StoryCta from "./StoryCta";

export default function StoryPanel({ progress, stage, index, total, active }) {
  const { opacity, y } = useStageMotion(progress, index, total, 0.045, 48);

  return (
    <motion.div
      style={{ opacity, y }}
      className={`absolute inset-x-0 bottom-0 ${active ? "" : "pointer-events-none"}`}
      aria-hidden={!active}
      data-testid={`story-panel-${index + 1}`}
    >
      <div className="flex items-center gap-4 mb-5">
        <span className={`w-2 h-2 rounded-full ${index === 0 ? "bg-[hsl(var(--bh-red-bright))]" : "bg-[hsl(var(--gaza-blue-bright))]"}`} />
        <span className="text-[11px] uppercase tracking-[0.3em] font-extrabold text-white/70">
          Stage {stage.n} <span className="text-white/35">/ {String(total).padStart(2, "0")}</span>
        </span>
      </div>
      <h3 className="display-chunky text-5xl md:text-6xl xl:text-[5.5rem] text-white leading-[0.9] max-w-4xl">{stage.title}</h3>
      <div className="mt-8 grid md:grid-cols-12 gap-8 items-end">
        <p className="md:col-span-7 text-white/80 text-lg xl:text-xl leading-relaxed max-w-xl">{stage.desc}</p>
        <div className="md:col-span-5 flex items-baseline gap-3 md:justify-end">
          <span className="display-chunky text-3xl text-[hsl(var(--gaza-blue-bright))]" data-testid={`story-stat-${index + 1}`}>{stage.stat}</span>
          <span className="text-[11px] uppercase tracking-[0.22em] text-white/55 font-extrabold">{stage.statLabel}</span>
        </div>
      </div>
      {index === total - 1 && <StoryCta className="mt-10" />}
    </motion.div>
  );
}
